import type { SlideProps } from "@/engine/app/offsite-config";

const STATS = [
  { value: "300.000", label: "Zeilen Code" },
  { value: "600", label: "Automatisierte Tests für Sicherheit & Qualität" },
  { value: "178.000", label: "Analysierte Gebäude" },
  { value: "1", label: "Entwickler" },
];

export function Slide04Stats(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 380,
          height: 380,
          top: "-100px",
          right: "-120px",
          background: "var(--svo-blau)",
          opacity: 0.3,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 280,
          height: 280,
          bottom: "-80px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.15,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Zahlen</div>
        <h1 className="deck-title rise rise-2">
          Wie kann eine Person <br />
          <span className="accent">das alles bauen?</span>
        </h1>
      </header>

      <div className="deck-big">
        <div
          className="big-grid rise rise-4"
          style={{ gridTemplateColumns: "repeat(2, 1fr)", gridTemplateRows: "1fr 1fr" }}
        >
          {STATS.map((s, i) => (
            <div key={i} className="big-tile">
              <div className="tile-eyebrow">0{i + 1}</div>
              <div className="tile-value">{s.value}</div>
              <div className="tile-label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
